import { GridColDef, GridRowModel } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useSlideInContext } from "../../SlideIn/SlideInProvider"
import { ADD_LOCATION, HeaderActionType, TableHeader, TablePaginated, TableToolBar, TableToolBarStacked, useManageModal, } from "ui";
import { IconButton, Typography } from "@mui/material";
import { Add, Folder } from "@mui/icons-material";
import { useMutation, useQuery } from "@apollo/client";
import { GET_COMPANY_LOCATIONS } from "../../../queries";
import { useParams } from "react-router";
import { ADD_LOCATION_MUTATION } from "../../../mutations";
import { AddLocationMutation, AddLocationMutationVariables } from "../../../__generated__/graphql";
import { LOCATION_FORM_FIELDS } from "../../Forms/LocationForm";
interface LocationTableProps {
    handleSelectedLocation: (value: any) => void
}
const mapToTable = (data: any) => {
    return {
        ...data.node,
        postalCode: data.node.postalCode ?? "N/A"
    }
}
const TABLE_COLUMNS: GridColDef[] = [
    {
        field: "name", headerName: "Location Name", width: 150, sortable: true, flex: 1, resizable: false, editable: false, disableColumnMenu: true,
    },
    {
        field: "postalCode", headerName: "Postal Code", width: 100, flex: 1, resizable: false, editable: false, disableColumnMenu: true,
    }
]
export function LocationTable({ handleSelectedLocation }: LocationTableProps) {
    const { id } = useParams();
    const { handleContent } = useSlideInContext()
    const { openModal } = useManageModal()
    const { loading, data, fetchMore } = useQuery(GET_COMPANY_LOCATIONS, {
        notifyOnNetworkStatusChange: true,
        variables: {
            companyId: id,
            query: "",
            first: 100
        }
    })
    const [addLocation] = useMutation<AddLocationMutation, AddLocationMutationVariables>(ADD_LOCATION_MUTATION)
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[],
        filteredRows: GridRowModel[]
        status: "NORMAL" | "FILTERING"
    }>({
        columns: [],
        rows: [],
        filteredRows: [],
        status: "NORMAL"
    })

    useEffect(() => {
        setPageTableState((prevState) => {
            const columns = [...TABLE_COLUMNS]
            columns.push({
                field: "customFields", headerName: "Has Custom Fields", sortable: false, flex: 1, resizable: false, editable: false, disableColumnMenu: true,
                renderHeader: () => (
                    <div style={{ whiteSpace: "break-spaces", fontWeight: 500, lineHeight: 1, textAlign: "center" }}>Has Custom Fields</div>
                ),
                renderCell: (params) => {
                    const _customFields = params.row.customFields.length > 0 ? "Yes" : "No"
                    return (<Typography textAlign="center" justifyContent="center">{_customFields}</Typography>)
                }
            })
            columns.push({
                field: "details", headerName: "Details", flex: .5, headerAlign: "center", align: "center", sortable: false, resizable: false, editable: false, disableColumnMenu: true,
                renderCell: (params) => {
                    const onClick = () => { handleSelectedLocation(params.row) }
                    return <IconButton onClick={onClick}>
                        <Folder />
                    </IconButton>
                }
            })
            const rows = data?.locationsByCompanyId?.edges?.map(mapToTable) ?? [];

            return {
                ...prevState,
                columns,
                rows,
                filteredRows: []
            }
        })
    }, [data, loading])
    const addNewLocationSlideIn = () => {
        handleContent(ADD_LOCATION, {
            locationFormFields: LOCATION_FORM_FIELDS,
            onSubmit: async (values: any) => {
                await handleAddNewLocation(values)
            }
        })
    }
    const handleAddNewLocation = async (values: any) => {
        try {
            const input = { ...values }
            const response = await addLocation({
                variables: {
                    input: {
                        ...values,
                        companyId: id
                    }
                },
                refetchQueries: [GET_COMPANY_LOCATIONS]
            })

            console.log("values: ", input)
        } catch {
            openModal({ type: "GENERAL_ERROR", cancelButtonLabel: "Close" })
        }
    }
    const headerActions: HeaderActionType[] = [{
        name: "Add new Location",
        icon: <Add />,
        action: addNewLocationSlideIn
    }]
    return <TablePaginated
        loading={loading}
        renderToolbar={() => (
            <TableHeader
                title="Locations"
                headerActions={headerActions} />)}
        // <TableToolBarStacked
        //     title="Locations"
        //     searchQuery={searchQuery ?? ""}
        //     onSearch={onSearch}
        //     headerActions={headerActions}
        //     onSearchClear={onSearchClear} />)}
        // renderToolbar={({ searchQuery, onSearch, onSearchClear }) => (
        //     <TableToolBarStacked
        //         title="Locations"
        //         searchQuery={searchQuery ?? ""}
        //         onSearch={onSearch}
        //         headerActions={headerActions}
        //         onSearchClear={onSearchClear} />)}
        rows={pageTableState.status === "FILTERING"
            ? pageTableState.filteredRows
            : pageTableState.rows}
        columns={pageTableState.columns}
        pageSize={5}
        getRowClassName={(params) => params.row.status === null ? "Active" : "Expired"}
        pageInfo={data?.locationsByCompanyId?.pageInfo}
        autoHeight
        disableBoxShadow
        totalRows={data?.locationsByCompanyId?.totalCount ?? 0}
        onFetchMore={async ({ query }) => {
            await fetchMore({
                variables: {
                    companyId: id,
                    query
                },
            })
        }}
    />
}